import src from "IMAGE";
export default { src, width: 150, height: 110, blurWidth: 0, blurHeight: 0};
